import { createFileRoute } from '@tanstack/react-router'

import RewardPage from '@/views/loyalty/reward/reward.page'

export const Route = createFileRoute('/phong-nha/loyalty/reward')({
  component: RewardPage,
})

